import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowButton } from '../ui/ArrowButton';
import { Counter } from '../ui/Counter';
import { Reveal } from '../ui/Reveal';
import { ScrollRevealText } from '../ui/ScrollRevealText';
import { SectionLabel } from '../ui/SectionLabel';
import { images } from '../../data/images';
const pillars = [{
  title: 'Approche terrain',
  text: 'Usines, entrepôts, rencontres fournisseurs : je travaille là où les coûts se créent.'
}, {
  title: 'Résultats chiffrés',
  text: 'Chaque gain est mesuré avec vos chiffres et validé par votre direction financière.'
}, {
  title: 'Indépendance',
  text: 'Aucun lien avec les fournisseurs ou les éditeurs : seul votre intérêt compte.'
}];
export function IntroSection() {
  const imageRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: imageRef,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-6%', '6%']);
  return <section className="bg-paper py-24 lg:py-36" data-id="element-182" data-mp="1feajblv05zmg">
      <div className="mx-auto grid max-w-[1440px] gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:items-center lg:gap-20" data-id="element-183" data-mp="1fczfxn5gytvv">
        <div className="relative lg:col-span-5" data-id="element-184" data-mp="16ef495ybtkh5">
          <div ref={imageRef} className="relative aspect-[4/5] overflow-hidden rounded-[28px] bg-mist" data-id="element-185" data-mp="16d3zp3x248oz">
            <motion.img src={images.portrait} alt="La fondatrice de L Procure Consulting" style={{
            y
          }} className="absolute inset-x-0 -top-[8%] h-[116%] w-full object-cover object-top" data-id="element-186" data-mp="11f2lawaksxju" />
          </div>
          <Reveal delay={0.15} className="absolute -bottom-8 right-4 sm:-right-6" data-id="element-187" data-mp="mpwikycj4p77">
            <div className="rounded-2xl bg-ink px-6 py-5 text-white shadow-[0_24px_50px_-20px_rgba(14,23,38,0.6)]" data-id="element-188" data-mp="ipmexsc7mavi">
              <p className="text-5xl font-medium tracking-tight text-brass" data-id="element-189" data-mp="doye6ey6ifo3">
                <Counter value={20} prefix="+" data-id="element-190" data-mp="8qddyfixfvzn" />
              </p>
              <p className="mt-1 text-sm leading-snug text-white/70" data-id="element-191" data-mp="8sztp2fz1hsy">
                années en achats
                <br data-id="element-192" data-mp="3vb1mczprbene" />& supply chain
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7" data-id="element-193" data-mp="401ahi7p08r6">
          <Reveal data-id="element-194" data-mp="3lban6kq94bgz">
            <SectionLabel data-id="element-195" data-mp="3lbss05qzby0i">À propos</SectionLabel>
          </Reveal>
          <ScrollRevealText text="Depuis plus de vingt ans, je transforme les dépenses des entreprises en levier de performance, et leurs fournisseurs en véritables partenaires." className="mt-6 text-[clamp(1.7rem,3.2vw,2.75rem)] font-medium leading-[1.18] tracking-[-0.02em] text-ink" data-id="element-196" data-mp="3q92hfledc9oc" />
          <Reveal delay={0.1} data-id="element-197" data-mp="837nr9t83075">
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-198" data-mp="81wljeffe0i5">
              Acheteuse, responsable de catégories puis directrice achats et supply chain, j’ai fondé L Procure
              Consulting pour mettre cette expérience opérationnelle au service des entreprises qui veulent des
              résultats concrets, sans usine à gaz.
            </p>
          </Reveal>

          <div className="mt-12 grid gap-8 sm:grid-cols-3" data-id="element-199" data-mp="2q7xos5b23pwx">
            {pillars.map((p, i) => <Reveal key={p.title} delay={0.08 * i} data-id="element-200" data-mp="2lafdi89kgylr" data-mpi={i}>
                <div className="border-t border-ink/15 pt-5" data-id="element-201" data-mp="2zzv0dd5z8jw6">
                  <h3 className="font-medium text-ink" data-id="element-202" data-mp="301efv1jt6qww">{p.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-203" data-mp="2v10icdfu2zd4">{p.text}</p>
                </div>
              </Reveal>)}
          </div>

          <Reveal delay={0.2} className="mt-12" data-id="element-204" data-mp="22ccr818elfrn">
            <ArrowButton to="/a-propos" data-id="element-205" data-mp="22dnzoecsnbp3">Découvrir mon parcours</ArrowButton>
          </Reveal>
        </div>
      </div>
    </section>;
}